import controller from './controller';
import template from './template.html';

const controllerAs = 'fileUploadCtrl';
const bindings = {
  policyType: '<',
  preview: '<',
  previewStatus: '<',
  fileType: '<',
  policyConfig: '<',
  inputName: '<',
  action: '&',
  actionConfig: '<'
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/forms/fileUpload/index.js